import React from 'react';
import { RGB_2_HEX, isColorBright } from '../../lib/ep';

const FloatingTag = (props) => {
	return null;	// we don't display this icon anymore

	const pending = (props.pending != undefined) ? props.pending : false;
	const has_participated = (props.has_participated != undefined && !pending) ? props.has_participated : false;

	if(pending) {
		return (
			<div class="status_icon">
				<span class="s_icon blueBg knk-zipped original_color_item" />
			</div>
		)
	}

	if(has_participated) {
		return (
			<div class="status_icon">
				<span class="s_icon greenBg knk-follower original_color_item" />
			</div>
		)
	}

	return null;
};

const StageImage = (props) => {
	const open = (props.open != undefined) ? props.open : false;
	const pending = (props.pending != undefined) ? props.pending : false;
	const is_bg = (props.is_bg != undefined) ? props.is_bg : false;
	const in_galleries = (props.in_galleries != undefined) ? props.in_galleries : false;
	const can_participate_again = (props.can_participate_again != undefined) ? props.can_participate_again : true;
	const has_participated = (props.has_participated != undefined && !pending) ? props.has_participated : false;
	const img_props = (props.img_props != undefined) ? props.img_props : '120x63';
	const stage_title = (props.stage_title != undefined && props.stage_title !== false && !is_bg) ? props.stage_title : "";
	const stage_picture = (props.stage_picture != undefined) ? props.stage_picture : false;

	if(is_bg && !open) return null;

	const img_class = (is_bg) ? 'img_self_bg' : 'img_self';

	if(stage_picture) {
		return (
			<span class={img_class} style={{backgroundImage:'url(' + stage_picture + ')'}}>
				<img src={`${window.cdn_url}img/blank_${img_props}.png`} width="100%" alt={stage_title} />
				{/*<img src={`${window.cdn_url}img/vignette_${img_props}.png`} width="100%" alt={stage_title} />*/}

				{(!in_galleries) && (
					<FloatingTag pending={pending} has_participated={has_participated} />
				)}
			</span>
		)
	}

	const default_promo_color = (props.default_promo_color != undefined) ? props.default_promo_color : 'rgba(0, 0, 0, 1)';
	const default_promo_color_array = convertRGBAtoArray(default_promo_color);
	const is_light_color = isColorBright(RGB_2_HEX(`rgba(${default_promo_color_array[0]}, ${default_promo_color_array[1]}, ${default_promo_color_array[2]}, 1)`));
	const icon = (props.icon != undefined) ? props.icon : '';

	return (
		<span class={img_class} style={{backgroundColor:default_promo_color}}>
			<span class="stage_icon">
				<span class={'original_color_item ' + ((!is_light_color) ? 'whiteBg' : 'blackBg') + ' ' + icon} style={{color:default_promo_color}} />
			</span>

			<img src={`${window.cdn_url}img/vignette_${img_props}.png`} width="100%" alt={stage_title} />

			{(!in_galleries) && (
				<FloatingTag pending={pending} has_participated={has_participated} />
			)}
		</span>
	)
};

export default StageImage;